'use strict';

require('../common');

module.exports = function () {
  const urlParams = new URLSearchParams(window.location.search);
  const getFrom = urlParams.get('from');

  if (getFrom) {
    log('Fix FB Conversion');
    localStorage.setItem("from", getFrom);
  }
}

